"use strict";

exports.__esModule = true;
exports.default = exports.grants = void 0;
const grants = ['create_company', 'edit_company', 'delete_company', 'read_companies'];
exports.grants = grants;
var _default = grants;
exports.default = _default;